export const getRoles = (userType) =>
{
    const roles = {
        create: false,
        edit: false,
        redeem: false,
        hide: []
    };

    if (userType === 'admin')
    {
        roles.create = true;
        roles.redeem = false;
        roles.edit = true;
        roles.hide = ['']

    } else if (userType === 'user')
    {
        roles.create = false;
        roles.redeem = false;
        roles.edit = false;
        roles.hide = ['createSale', 'createObservantUser', 'logs', 'createManager']

    } else if (userType === 'salesAgent')
    {
        roles.create = false;
        roles.redeem = true;
        roles.edit = false;
        roles.hide = ['createSale', 'observantUsers', 'logs', 'createManager', 'regionalManagers', 'salesRepresentative']

    } else if (userType === 'regionalManager')
    {
        roles.create = false;
        roles.redeem = false;
        roles.edit = true;
        roles.hide = ['observantUsers', 'logs', 'points', 'createManager', 'services', 'sales', "regionalManagers", "allRegionalManagers", "createManager"]
    }

    return roles;
};